<template>
  <div>

    <!-- Step 1: Campaign -->
    <h4 class="mb-3">
      <div class="badge badge-danger step">
        {{ $t('donation-form.step') }} 1
      </div>
      {{ $t('donation-form.campaign_section_title') }}
    </h4>

    <!--  Click on campaign notice -->
    <div class="mb-3 text-13 text-red d-flex align-items-center">
      <i class="fas fa-hand-pointer me-2"></i>
      * {{ $t('donation-form.campaign_section_instructions') }}
    </div>

    <div class="row">
      <template v-for="campaign in campaigns" :key="campaign.id">
        <div class="col-md-6 col-12 campaign-column d-flex flex-column">
          <!-- Campaign Info Card -->
          <div
              class="border d-flex flex-column h-100 p-3 campaign-info-card"
              :class="{ 'card-selected': isSelected(campaign.name), 'bg-light': ! isSelected(campaign.name) }"
              @click="$emit('addCampaign', campaign.name)"
          >

            <!-- Campaign name -->
            <h5 class="mb-3 d-flex align-items-center justify-content-between">
              {{ campaign.name }}
              <i class="fas fa-check-circle selected-icon" v-if="isSelected(campaign.name)"></i>
            </h5>

            <!-- Amount raised -->
            <div class="mb-2 text-13">
              {{ $t('donation-form.amount_raised') }}
              <div class="amount" style="font-size: 32px!important;">
                {{ vueNumberFormat(campaign.transactions_sum_amount) }}
              </div>
            </div>

            <!-- Progress Bar -->
            <div class="progress-bar-wrapper">
              <div class="progress border" style="height: 24px;">
                <div class="progress-bar-striped progress-bar-animated bg-success text-white text-center" role="progressbar" :aria-valuenow="campaign.amount_raised_percentage" aria-valuemin="0" aria-valuemax="100" :style="{ width: campaign.amount_raised_percentage + '%' }">
                  <div class="progress-percent-value text-white">
                    {{ (campaign.amount_raised_percentage) }}%
                  </div>
                </div>
              </div>
            </div>

            <!-- Targeted amount -->
            <div class="mt-2 text-13">
              {{ $t('donation-form.target') }} <b>{{ vueNumberFormat(campaign.targeted_amount) }}</b>
            </div>

            <!-- Countdown timer -->
            <countdown :campaign="campaign" v-if="campaign.countdown_enabled"/>
          </div>

          <!-- Selection Button-->
          <button
              type="button"
              class="btn btn-sm w-100 select-button mt-2 py-2"
              :class="isSelected(campaign.name) ? 'btn-primary' : 'btn-outline-primary'"
              @click.prevent="$emit('addCampaign', campaign.name)"
          >
            <i class="fas" :class="isSelected(campaign.name) ? 'fa-check-circle' : 'fa-hand-holding-heart'"></i>
            {{ isSelected(campaign.name) ? $t('donation-form.selected', 'Selected') : $t('donation-form.select_campaign', 'Select Campaign') }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<!-- Scripts -->
<script setup>
import Countdown from "@/Pages/Donations/ModernForm/Countdown";
import useHelpers from "@/Composables/UseHelpers";

const { $t } = useHelpers();

const props = defineProps({
  campaigns: {
    type: Array
  },
  selectedCampaigns: {
    type: Array
  }
});

function isSelected(campaign) {
  return props.selectedCampaigns.indexOf(campaign) >= 0
}
</script>

<style scoped>
.campaign-column {
  margin-bottom: 2rem;
}

.campaign-info-card {
  transition: all 0.3s ease;
  border-radius: 0.375rem;
  background-color: #f8f9fa;
  cursor: pointer;
}

.campaign-info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: #007bff !important;
}

.card-selected {
  border-color: #28a745 !important;
  background-color: #f8fff9 !important;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2);
}

.card-selected:hover {
  border-color: #28a745 !important;
}

.selected-icon {
  color: #28a745;
  font-size: 18px;
}

.select-button {
  transition: all 0.2s ease;
  font-weight: 500;
}

.select-button:hover {
  transform: translateY(-1px);
}

.select-button i {
  margin-right: 6px;
}

@keyframes subtle-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.1); }
  50% { box-shadow: 0 0 0 4px rgba(0, 123, 255, 0.05); }
}

.campaign-info-card:not(.card-selected):not(:hover) {
  animation: subtle-pulse 3s infinite;
}

@media (max-width: 768px) {
  .campaign-info-card:hover {
    transform: none;
  }

  .select-button:hover {
    transform: none;
  }

  .campaign-column {
    margin-bottom: 3.5rem !important;
  }

  .select-button {
    margin-bottom: 1rem;
  }
}
</style>